<template>
    <div class="column">
        <h5 v-if="isExistingTitle" class="column__title">
            <slot name="title">
                {{ column.title }}
            </slot>
        </h5>

        <slot>
            <ul class="column__list">
                <li class="column__list-item" v-for="(item, index) in items" :key="index">
                    <MyActionBtn
                        class="column__list-item__btn"
                        v-if="item.scroll"
                        :btnText="item.label"
                        :theme="'transparent'"
                        :type="'text'"
                        @click="scrollToFaq"
                    />
                    <component v-else :is="getComponentName(item.type)" :item="item" />
                </li>
            </ul>
        </slot>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { ColumnStructure } from '@/themes/ecaterix/components/widgets/Footer/types';

export default {
    name: 'Column',
    props: {
        column: VueTypes.oneOfType([ColumnStructure]).isRequired
    },
    components: {
        LinksList: () => import('./components/LinksList'),
        ContactsContent: () => import('./components/ContactsContent'),
        MyActionBtn: () => import('@/themes/ecaterix/components/ui/MyActionBtn')
    },
    computed: {
        isExistingTitle() {
            return !!this.column?.title?.length;
        },
        items() {
            return this.column?.items || [];
        }
    },
    methods: {
        smoothScrollTo(element, duration = 1000, offset = 0) {
            const targetPosition = element.getBoundingClientRect().top + window.scrollY;
            const startTime = performance.now();

            const easeInOutQuad = t => {
                return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            };

            const animateScroll = currentTime => {
                const elapsedTime = currentTime - startTime;
                const progress = Math.min(elapsedTime / duration, 1);
                const easing = easeInOutQuad(progress);
                const scrollPosition = targetPosition * easing;
                window.scrollTo(0, scrollPosition);

                if (elapsedTime < duration) {
                    requestAnimationFrame(animateScroll);
                }
            };

            requestAnimationFrame(animateScroll);
        },
        smoothScroll() {
            this.$nextTick(() => {
                const faqElement = document.querySelector('.questions-scroll');
                if (faqElement) {
                    this.smoothScrollTo(faqElement, 1500, 50);
                } else {
                    this.waitForElement('.questions-scroll', 1000).then(element => {
                        this.smoothScrollTo(element, 1500, 50);
                    });
                }
            });
        },
        scrollToFaq() {
            if (this.$route.path === this.localePath('/')) {
                this.smoothScroll();
            } else {
                this.$router
                    ?.replace(this.localePath('/'))
                    .then(() => {
                        this.smoothScroll();
                    })
                    .catch(error => {
                        this.smoothScroll();
                    });
            }
        },
        waitForElement(selector, interval = 100, timeout = 5000) {
            return new Promise((resolve, reject) => {
                const startTime = new Date().getTime();

                const timer = setInterval(() => {
                    const element = document.querySelector(selector);

                    if (element) {
                        clearInterval(timer);
                        resolve(element);
                    } else {
                        const elapsedTime = new Date().getTime() - startTime;
                        if (elapsedTime >= timeout) {
                            clearInterval(timer);
                            reject(new Error('Element not found within timeout'));
                        }
                    }
                }, interval);
            });
        },
        getComponentName(type) {
            return ['image', 'link', 'tagLink'].includes(type) ? 'LinksList' : 'ContactsContent';
        }
    }
};
</script>

<style lang="scss">
@import './styles.scss';
</style>
